export default class Faq {
  static init() {
    const questions = document.querySelectorAll(".question");

    questions.forEach(function (question) {
      //const btn = question.querySelector(".question-btn");

      question.addEventListener("click", function (el) {
        console.log(el);
        questions.forEach(function (item) {
          if (item !== question) {
            item.classList.remove("show-text");
          }
        });
        question.classList.toggle("show-text");
      });
    });
  }
}
